import { jsxs as f, jsx as i } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { cn as d } from "../../utils/cn.js";
const m = n(
  ({ children: t, withGap: l = !1, onExpand: e, expandText: c = "See All", className: o, isExpandDisabled: s, ...r }, a) => /* @__PURE__ */ f(
    "div",
    {
      ref: a,
      className: d("flex flex-col", l ? "gap-3" : "bg-background-secondary rounded-2xl", o),
      ...r,
      children: [
        t,
        !!e && /* @__PURE__ */ i(
          "button",
          {
            className: "text-accent focus:text-accent-2 w-full self-center p-3",
            disabled: s,
            type: "button",
            onClick: e,
            children: c
          }
        )
      ]
    }
  )
);
m.displayName = "List";
export {
  m as List
};
//# sourceMappingURL=index.js.map
